var _g, _path, _path2, _path3, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetsCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 115,
    viewBox: "0 0 119 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5598_106001)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5598_106001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9265 72.4555C60.9265 78.6978 69.1102 83.7582 79.2052 83.7582C89.3003 83.7582 97.4839 78.6978 97.4839 72.4555C97.4839 71.8082 97.478 69.8786 97.4603 69.2617C97.3849 66.6218 95.1003 59.582 79.2052 59.582C63.0791 59.582 60.9986 67.5018 60.9489 69.2617C60.9313 69.8856 60.9265 71.8158 60.9265 72.4555Z",
    fill: "#F19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9265 68.5684C60.9265 62.3261 69.1102 57.2657 79.2052 57.2657C89.3003 57.2657 97.4839 62.3261 97.4839 68.5684C97.4839 74.8107 89.3003 79.8711 79.2052 79.8711C69.1102 79.8711 60.9265 74.8107 60.9265 68.5684Z",
    fill: "#FFC32D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5179 76.8282C77.2732 78.6231 69.047 76.4466 66.1443 71.9668C63.2416 67.487 66.7614 62.4004 74.0062 60.6055C81.2509 58.8105 89.477 60.9871 92.3798 65.4669C95.2825 69.9467 91.7626 75.0333 84.5179 76.8282Z",
    fill: "#F39E09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0062 60.6055C81.2509 58.8105 89.477 60.9871 92.3798 65.4669C87.5374 65.4669 74.0062 65.4669 66.1443 71.9668C63.2416 67.487 66.7614 62.4004 74.0062 60.6055Z",
    fill: "#FFAA16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.89 65.8862C67.3952 64.0914 69.9061 62.6122 73.1786 61.8014C80.421 60.0071 88.6504 62.1844 91.5522 66.6628C92.8634 68.6864 92.8668 70.8308 91.8065 72.7434C93.6303 70.5624 93.9731 67.9259 92.3798 65.4669C89.478 60.9885 81.2485 58.8111 74.0062 60.6055C70.0363 61.589 67.182 63.5645 65.89 65.8862Z",
    fill: "#E88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9244 58.5326C82.9956 58.3415 82.7718 58.1543 82.422 58.1221C80.3391 57.9304 78.209 57.9446 76.1321 58.1651C73.8448 58.4079 71.6669 58.896 69.7227 59.6016C67.7785 60.3073 66.1061 61.2165 64.8009 62.2776C63.6158 63.2411 62.7546 64.3125 62.2563 65.441C62.1726 65.6305 62.3977 65.8173 62.7452 65.8564V65.8564C63.0926 65.8956 63.4307 65.7722 63.5154 65.5828C63.9792 64.5451 64.7741 63.5599 65.8648 62.6733C67.0754 61.6891 68.6267 60.8456 70.4302 60.1911C72.2336 59.5365 74.2538 59.0837 76.3755 58.8585C78.2868 58.6556 80.2467 58.6411 82.1641 58.8144C82.5141 58.8461 82.8533 58.7237 82.9244 58.5326V58.5326Z",
    fill: "#FFE77E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2566 78.3277C80.286 78.5301 80.6042 78.6816 80.9656 78.6579C84.9609 78.3956 88.6887 77.4016 91.5647 75.8317C91.8248 75.6897 91.8136 75.4564 91.5499 75.3165V75.3165C91.2862 75.1765 90.87 75.1829 90.6092 75.3245C87.9575 76.7638 84.5313 77.6774 80.859 77.9243C80.4977 77.9486 80.2272 78.1253 80.2566 78.3277V78.3277Z",
    fill: "#FFE77E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1804 68.1946C88.5851 67.9282 88.239 66.4841 87.6059 66.4841L80.1721 67.5244C79.6389 67.5244 79.2773 67.2277 79.4824 66.9584L82.2009 63.3893C82.5308 62.9563 82.0052 61.5696 81.457 61.9304L69.1508 69.3442C68.7461 69.6105 69.6125 71.0547 70.2455 71.0547L77.6794 71.0547C78.2126 71.0547 78.5741 71.3515 78.369 71.6208L75.1304 74.1494C74.8005 74.5825 76.3665 75.9692 76.9147 75.6084L88.1804 68.1946Z",
    fill: "#E88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1804 67.1557C88.5851 66.8894 88.2389 66.4856 87.6059 66.4856L80.172 66.4856C79.6389 66.4856 79.2773 66.1888 79.4824 65.9195L82.2009 62.3505C82.5307 61.9174 81.4849 61.5711 80.9367 61.9319L69.671 69.3457C69.2663 69.6121 69.6125 70.0159 70.2455 70.0159L77.6794 70.0159C78.2125 70.0159 78.5741 70.3126 78.369 70.5819L75.6505 74.151C75.3207 74.584 76.3665 74.9303 76.9147 74.5696L88.1804 67.1557Z",
    fill: "#FFDD28"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5598_106001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4059 72.5766C41.4059 78.8189 49.5895 83.8793 59.6846 83.8793C69.7797 83.8793 77.9633 78.8189 77.9633 72.5766C77.9633 71.9293 77.9573 69.9997 77.9397 69.3828C77.8642 66.7429 75.5796 59.7031 59.6846 59.7031C43.5584 59.7031 41.4779 67.6229 41.4283 69.3828C41.4107 70.0067 41.4059 71.9369 41.4059 72.5766Z",
    fill: "#F19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4059 68.6895C41.4059 62.4472 49.5895 57.3868 59.6846 57.3868C69.7797 57.3868 77.9633 62.4472 77.9633 68.6895C77.9633 74.9318 69.7797 79.9922 59.6846 79.9922C49.5895 79.9922 41.4059 74.9318 41.4059 68.6895Z",
    fill: "#FFC32D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9972 76.9532C57.7524 78.7481 49.5263 76.5716 46.6235 72.0918C43.7208 67.612 47.2407 62.5254 54.4854 60.7305C61.7301 58.9355 69.9563 61.1121 72.859 65.5919C75.7618 70.0717 72.2419 75.1583 64.9972 76.9532Z",
    fill: "#F39E09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4854 60.7305C61.7301 58.9355 69.9563 61.1121 72.859 65.5919C68.0166 65.5919 54.4854 65.5919 46.6235 72.0918C43.7208 67.612 47.2407 62.5254 54.4854 60.7305Z",
    fill: "#FFAA16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3693 66.0112C47.8744 64.2164 50.3853 62.7372 53.6578 61.9264C60.9002 60.1321 69.1297 62.3094 72.0315 66.7878C73.3427 68.8114 73.3461 70.9558 72.2857 72.8684C74.1096 70.6874 74.4524 68.0509 72.859 65.5919C69.9572 61.1135 61.7278 58.9361 54.4854 60.7305C50.5156 61.714 47.6612 63.6895 46.3693 66.0112Z",
    fill: "#E88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4038 58.6537C63.4749 58.4626 63.2511 58.2754 62.9013 58.2432C60.8185 58.0515 58.6883 58.0657 56.6114 58.2862C54.3241 58.529 52.1462 59.0171 50.202 59.7227C48.2578 60.4283 46.5854 61.3376 45.2803 62.3987C44.0951 63.3621 43.2339 64.4336 42.7356 65.5621C42.6519 65.7516 42.877 65.9384 43.2245 65.9775V65.9775C43.5719 66.0167 43.91 65.8933 43.9947 65.7039C44.4585 64.6662 45.2534 63.681 46.3441 62.7944C47.5547 61.8102 49.1061 60.9667 50.9095 60.3122C52.7129 59.6576 54.7331 59.2048 56.8548 58.9796C58.7661 58.7767 60.726 58.7621 62.6434 58.9355C62.9934 58.9672 63.3326 58.8447 63.4038 58.6537V58.6537Z",
    fill: "#FFE77E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.736 78.4527C60.7654 78.6551 61.0835 78.8066 61.4449 78.7829C65.4402 78.5206 69.168 77.5266 72.044 75.9567C72.3041 75.8147 72.2929 75.5814 72.0292 75.4415V75.4415C71.7655 75.3015 71.3493 75.3079 71.0885 75.4495C68.4368 76.8888 65.0106 77.8024 61.3383 78.0493C60.977 78.0736 60.7066 78.2503 60.736 78.4527V78.4527Z",
    fill: "#FFE77E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4131 69.2336C68.8178 68.9673 68.4716 67.5231 67.8386 67.5231L60.4047 68.5635C59.8715 68.5635 59.51 68.2667 59.7151 67.9974L62.4335 64.4284C62.7634 63.9953 62.2378 62.6086 61.6896 62.9694L49.9037 70.3833C49.4989 70.6496 49.8451 72.0938 50.4782 72.0938L57.912 72.0938C58.4452 72.0938 58.8068 72.3906 58.6017 72.6598L55.8832 75.1885C55.5533 75.6216 56.5991 77.0083 57.1473 76.6475L68.4131 69.2336Z",
    fill: "#E88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4131 68.1948C68.8178 67.9284 68.4716 67.5246 67.8386 67.5246L60.4047 67.5246C59.8715 67.5246 59.51 67.2278 59.7151 66.9586L62.4335 63.3895C62.7634 62.9565 61.7176 62.6102 61.1694 62.9709L49.9037 70.3848C49.4989 70.6511 49.8451 71.0549 50.4782 71.0549L57.912 71.0549C58.4452 71.0549 58.8068 71.3517 58.6017 71.621L55.8832 75.19C55.5533 75.6231 56.5991 75.9694 57.1473 75.6086L68.4131 68.1948Z",
    fill: "#FFDD28"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5598_106001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3936 70.3643C29.0687 75.6659 38.7797 77.0065 49.0839 73.3585C59.3881 69.7105 66.3833 62.4554 64.7082 57.1537C64.5345 56.604 63.4141 53.0792 63.2305 52.5616C62.4451 50.3468 58.2241 45.1934 41.9998 50.9373C25.5397 56.7647 25.5413 64.2428 25.9629 65.7555C26.1123 66.2918 27.2219 69.8209 27.3936 70.3643Z",
    fill: "#F19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9033 65.6462C24.2282 60.3445 31.2235 53.0894 41.5276 49.4414C51.8318 45.7934 61.5428 47.134 63.2179 52.4357C64.893 57.7373 57.8977 64.9924 47.5936 68.6404C37.2894 72.2884 27.5784 70.9478 25.9033 65.6462Z",
    fill: "#FFC22A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7348 49.0823C48.7679 48.8991 48.4914 48.795 48.1163 48.8571C45.8827 49.227 43.6444 49.7869 41.5071 50.511C39.1535 51.3085 36.9685 52.2897 35.0771 53.3985C33.1856 54.5073 31.6247 55.722 30.4834 56.9733C29.4471 58.1095 28.7752 59.2557 28.4977 60.3578C28.4511 60.5429 28.7288 60.6462 29.103 60.5907V60.5907C29.4771 60.5352 29.8059 60.3418 29.8536 60.1566C30.1147 59.1417 30.7357 58.087 31.6894 57.0414C32.748 55.8807 34.1959 54.7539 35.9504 53.7254C37.7049 52.6968 39.7317 51.7867 41.9149 51.047C43.8817 50.3806 45.9408 49.8642 47.9964 49.521C48.3715 49.4583 48.7017 49.2655 48.7348 49.0823V49.0823Z",
    fill: "#FFE77E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7059 68.5651C44.7811 68.7323 45.149 68.7812 45.5241 68.6679C49.6708 67.4145 53.376 65.5984 56.0588 63.5041C56.3015 63.3146 56.2387 63.1162 55.9306 63.0631V63.0631C55.6226 63.0101 55.186 63.1227 54.9425 63.3119C52.4671 65.2358 49.0617 66.9051 45.2515 68.0621C44.8767 68.176 44.6307 68.398 44.7059 68.5651V68.5651Z",
    fill: "#FFE77E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2002 64.1364C45.287 68.2788 36.3065 69.4029 32.1415 66.6471C27.9765 63.8913 30.2043 58.2992 37.1174 54.1568C44.0306 50.0143 53.0112 48.8903 57.1761 51.6461C61.3411 54.4019 59.1133 59.994 52.2002 64.1364Z",
    fill: "#F39E09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1174 54.1568C44.0306 50.0143 53.0112 48.8903 57.1761 51.6461C49.8245 52.8466 34.5164 61.5107 32.1415 66.6471C27.9765 63.8913 30.2043 58.2992 37.1174 54.1568Z",
    fill: "#FFAA16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2502 61.5747C31.3049 59.5064 33.4709 57.3427 36.5936 55.4715C43.5045 51.3305 52.4887 50.2059 56.6523 52.9608C58.5337 54.2057 59.1126 56.0257 58.5436 58.0332C59.8199 55.5219 59.4624 53.1588 57.1761 51.6461C53.0125 48.8912 44.0283 50.0157 37.1174 54.1568C33.3293 56.4267 30.9459 59.136 30.2502 61.5747Z",
    fill: "#E88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7084 55.2672C52.9766 54.8637 52.093 53.6701 51.5104 53.9179L45.0763 57.784C44.5857 57.9926 44.1368 57.861 44.2202 57.5329L45.3254 53.1848C45.4595 52.6572 44.4332 51.5867 44.0699 52.1332L36.6033 63.364C36.335 63.7675 36.74 65.1646 37.3226 64.9169L44.1637 62.0082C44.6544 61.7996 45.1032 61.9312 45.0199 62.2593L43.9863 65.4465C43.8522 65.9741 44.8784 67.0446 45.2418 66.4981L52.7084 55.2672Z",
    fill: "#E88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3013 54.3112C52.5695 53.9078 52.0929 53.6716 51.5104 53.9193L44.6692 56.828C44.1786 57.0367 43.7297 56.905 43.8131 56.577L44.9183 52.2288C45.0524 51.7012 43.9545 51.7917 43.5912 52.3382L36.1245 63.569C35.8563 63.9725 36.3329 64.2087 36.9155 63.9609L43.7566 61.0522C44.2473 60.8436 44.6961 60.9752 44.6127 61.3033L43.5075 65.6515C43.3734 66.1791 44.4713 66.0886 44.8347 65.5421L52.3013 54.3112Z",
    fill: "#FFDD28"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_5598_106001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2712 46.4083C86.7021 56.1792 77.0295 62.1044 67.6667 59.6427C58.3039 57.1809 54.4395 55.3768 58.8974 38.4222C63.2583 21.8362 67.6072 21.7975 76.97 24.2592C86.3328 26.721 91.8402 36.6375 89.2712 46.4083Z",
    fill: "#F19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6162 58.8401C55.2535 56.3784 49.746 46.4619 52.3151 36.691C54.8841 26.9202 64.5568 20.9949 73.9196 23.4567C83.2823 25.9184 88.7898 35.8349 86.2207 45.6058C83.6517 55.3767 73.979 61.3019 64.6162 58.8401Z",
    fill: "url(#paint0_linear_5598_106001)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.262 39.3505C82.0303 46.3407 77.1788 52.7728 70.4259 53.717C63.673 54.6613 57.5759 49.7602 56.8076 42.77C56.0393 35.7799 60.8907 29.3478 67.6436 28.4035C74.3965 27.4593 80.4937 32.3604 81.262 39.3505Z",
    fill: "#F39E09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5346 29.5497C75.2875 28.6054 78.3586 32.1327 79.61 34.2871C75.4718 35.4301 64.3741 42.129 60.403 49.7219C54.0356 40.1378 61.7817 30.4939 68.5346 29.5497Z",
    fill: "#FFAA16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1092 51.7686C60.0185 49.8086 58.5881 47.0799 58.2411 43.9224C57.473 36.9345 62.3264 30.4998 69.0771 29.5558C72.1275 29.1293 75.0407 29.8921 77.3938 31.5043C74.8521 29.1271 71.3504 27.8852 67.6436 28.4035C60.8929 29.3475 56.0395 35.7822 56.8076 42.77C57.2286 46.6004 59.2538 49.8073 62.1092 51.7686Z",
    fill: "#E88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7545 41.4403C79.2397 41.0939 79.1012 40.3388 78.5246 40.1872L71.7537 38.4069C71.2681 38.2792 71.0687 37.6986 71.3734 37.2995L75.4115 32.0094C75.9014 31.3675 73.5279 30.1271 72.8707 30.5963L60.9375 40.6532C60.4523 40.9997 60.5908 41.7548 61.1674 41.9064L67.9382 43.6866C68.4239 43.8143 68.6233 44.3949 68.3186 44.794L62.6045 50.0638C62.1146 50.7057 64.5915 51.553 65.2487 51.0837L78.7545 41.4403Z",
    fill: "#E88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0533 40.9911C77.5385 40.6446 77.3999 39.8896 76.8233 39.738L70.0525 37.9577C69.5669 37.83 69.3675 37.2494 69.6721 36.8503L73.7102 31.5602C74.2002 30.9183 73.3993 30.0913 72.7421 30.5606L59.2362 40.204C58.751 40.5505 58.8896 41.3056 59.4662 41.4572L66.237 43.2374C66.7226 43.3651 66.9221 43.9457 66.6174 44.3448L62.5793 49.6349C62.0893 50.2768 62.8902 51.1038 63.5474 50.6345L77.0533 40.9911Z",
    fill: "#FFD83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7838 26.7823C76.9295 26.4869 76.8097 26.1283 76.5106 25.9935C74.7296 25.1904 72.8178 24.7126 70.865 24.5842C68.7145 24.4428 66.5564 24.7279 64.514 25.4234C62.4715 26.1188 60.5848 27.2108 58.9614 28.6372C57.4873 29.9324 56.2566 31.4802 55.3261 33.2065C55.1698 33.4964 55.291 33.8545 55.585 34.0002V34.0002C55.8791 34.1458 56.2345 34.0238 56.3916 33.7343C57.2523 32.1483 58.3866 30.7257 59.7432 29.5338C61.249 28.2108 62.9992 27.1978 64.8937 26.5527C66.7882 25.9076 68.7901 25.6431 70.7849 25.7743C72.582 25.8924 74.3416 26.3296 75.9825 27.0639C76.282 27.1979 76.638 27.0777 76.7838 26.7823V26.7823Z",
    fill: "#FFE77E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4921 56.9309C66.4343 57.2552 66.6492 57.5657 66.9741 57.6114C70.5661 58.1159 74.2266 57.4112 77.3819 55.6077C77.6673 55.4445 77.7538 55.0759 77.5816 54.7959V54.7959C77.4094 54.5159 77.0439 54.4306 76.758 54.5929C73.8521 56.243 70.4878 56.8907 67.1837 56.4361C66.8587 56.3914 66.55 56.6066 66.4921 56.9309V56.9309Z",
    fill: "#FFE77E"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_5598_106001)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.2708 99.2192L105.772 88.2831C105.895 88.0766 105.95 87.8489 105.932 87.6212C105.914 87.3934 105.824 87.1729 105.669 86.9803C105.515 86.7876 105.301 86.6289 105.049 86.519C104.796 86.4091 104.512 86.3515 104.224 86.3516H90.5364C90.1771 86.3515 89.827 86.4409 89.5355 86.6072C89.2441 86.7735 89.0262 87.0082 88.9127 87.278L82.0688 103.532C82.0109 103.67 81.9814 103.814 81.9816 103.96V110.732C81.9816 111.092 82.1618 111.436 82.4827 111.69C82.8036 111.944 83.2388 112.087 83.6925 112.087H104.224C104.512 112.087 104.796 112.029 105.049 111.919C105.301 111.809 105.515 111.651 105.669 111.458C105.824 111.265 105.914 111.045 105.932 110.817C105.95 110.589 105.895 110.362 105.772 110.155L99.2708 99.2192Z",
    fill: "#3703A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0143 87.278C36.9008 87.0082 36.6829 86.7735 36.3914 86.6072C36.1 86.4409 35.7498 86.3515 35.3906 86.3516H21.7029C21.4156 86.3527 21.1333 86.4112 20.8821 86.5215C20.6308 86.6318 20.4187 86.7904 20.2652 86.9827C20.1118 87.1751 20.022 87.3949 20.0042 87.6219C19.9863 87.8489 20.041 88.0758 20.1631 88.2817L26.6647 99.2178L20.1631 110.155C20.0406 110.361 19.9856 110.588 20.0033 110.816C20.021 111.043 20.1107 111.263 20.2641 111.455C20.4176 111.648 20.6299 111.807 20.8814 111.917C21.1328 112.027 21.4154 112.086 21.7029 112.087H42.2344C42.6882 112.087 43.1234 111.944 43.4443 111.69C43.7651 111.436 43.9454 111.092 43.9454 110.732V103.96C43.9455 103.814 43.9161 103.67 43.8581 103.532L37.0143 87.278Z",
    fill: "#3703A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4488 82.4297H35.2827C34.2005 82.4297 33.3232 83.1262 33.3232 83.9854V108.099C33.3232 108.959 34.2005 109.655 35.2827 109.655H90.4488C91.531 109.655 92.4083 108.959 92.4083 108.099V83.9854C92.4083 83.1262 91.531 82.4297 90.4488 82.4297Z",
    fill: "#5A34E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5598_106001",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 82,
    width: 60,
    height: 28
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4488 82.4297H35.2827C34.2005 82.4297 33.3232 83.1262 33.3232 83.9854V108.099C33.3232 108.959 34.2005 109.655 35.2827 109.655H90.4488C91.531 109.655 92.4083 108.959 92.4083 108.099V83.9854C92.4083 83.1262 91.531 82.4297 90.4488 82.4297Z",
    fill: "#FF463A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5598_106001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1888 96.3337C76.1888 103.372 70.4832 109.078 63.445 109.078C56.4067 109.078 50.7011 103.372 50.7011 96.3337C50.7011 89.2955 56.4067 83.5898 63.445 83.5898C70.4832 83.5898 76.1888 89.2955 76.1888 96.3337ZM53.0081 96.3337C53.0081 102.098 57.6809 106.771 63.445 106.771C69.2091 106.771 73.8818 102.098 73.8818 96.3337C73.8818 90.5696 69.2091 85.8969 63.445 85.8969C57.6809 85.8969 53.0081 90.5696 53.0081 96.3337Z",
    fill: "#8133CF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3536 96.3303C88.3536 110.087 77.2017 121.239 63.4451 121.239C49.6886 121.239 38.5367 110.087 38.5367 96.3303C38.5367 82.5738 49.6886 71.4219 63.4451 71.4219C77.2017 71.4219 88.3536 82.5738 88.3536 96.3303ZM43.0458 96.3303C43.0458 107.597 52.1789 116.73 63.4451 116.73C74.7113 116.73 83.8444 107.597 83.8444 96.3303C83.8444 85.0641 74.7113 75.931 63.4451 75.931C52.1789 75.931 43.0458 85.0641 43.0458 96.3303Z",
    fill: "#8133CF",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5598_106001",
    x: 0.696104,
    y: 0.377368,
    width: 118.312,
    height: 101.904,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.2173
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.65189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.78 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5598_106001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5598_106001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5598_106001",
    x: 56.0031,
    y: 56.0586,
    width: 46.2748,
    height: 35.1594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.57384
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5598_106001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5598_106001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5598_106001",
    x: 36.4825,
    y: 56.1836,
    width: 46.2748,
    height: 35.1594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.57384
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5598_106001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5598_106001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5598_106001",
    x: 17.426,
    y: 40.5391,
    width: 55.6234,
    height: 46.9016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.57384
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5598_106001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5598_106001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5598_106001",
    x: 49.1102,
    y: 21.6115,
    width: 43.3658,
    height: 42.4485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5598_106001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5598_106001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_5598_106001",
    x: 20.0001,
    y: 82.4297,
    width: 85.9354,
    height: 31.9733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.31706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5598_106001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5598_106001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5598_106001",
    x1: 73.9196,
    y1: 23.4567,
    x2: 64.6162,
    y2: 58.8401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#FFBF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC536"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetsCoins);
export default __webpack_public_path__ + "static/media/pets_coins.5dd0abf7e0150c4f2f6baeb852657fbf.svg";
export { ForwardRef as ReactComponent };